export class Person {
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    telephone: string;
    age: number;

    constructor(props?: { [key in keyof Person]?: Person[key] }) {
        Object.assign(this, props);
    }
}
